// extracted by mini-css-extract-plugin
module.exports = {"bold":"style__bold__OzImM","center":"style__center__FCthq","right":"style__right__m47VE","noWrap":"style__noWrap__Pop+X"};